export default "__VITE_ASSET__BFbh7WDM__"